var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('history-stack',_vm._b({attrs:{"default-view-component":function () { return import('./GeotagCard.vue'); }},on:{"stack:close":_vm.handleClose}},'history-stack',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }